import { render, staticRenderFns } from "./ibc_register_info.vue?vue&type=template&id=8b80f146&scoped=true&"
import script from "./ibc_register_info.vue?vue&type=script&lang=js&"
export * from "./ibc_register_info.vue?vue&type=script&lang=js&"
import style0 from "./ibc_register_info.vue?vue&type=style&index=0&id=8b80f146&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b80f146",
  null
  
)

export default component.exports